export class BaseDocument {
  id = "";
  status = "";
  progress = 0;
  isCompleted = false;
  createdOn = new Date("0001-01-01T00:00:00Z");
  modifiedOn = new Date("0001-01-01T00:00:00Z");
  type = "";
}

export class BaseAgentDocument extends BaseDocument {
  agentId = "";
}

export class BaseClientDocument extends BaseAgentDocument {
  clientId = "";
}
